import { ETAPE_INFO, type Etape } from '@dinertournant/core';
import { IconeEtape } from './icones.js';

interface Props {
  etape: Etape;
  /** Texte secondaire (heure, « 4 tables »…). */
  detail?: string | undefined;
  /** `numero` : carré numéroté (écrans organisateur) ; `icone` : icône teintée (pages mobiles). */
  variante?: 'numero' | 'icone';
  grande?: boolean;
}

/** Pastille d'étape : une étape ne se distingue jamais par la couleur seule, toujours numéro + libellé + icône. */
export function PastilleEtape({ etape, detail, variante = 'icone', grande = false }: Props) {
  const info = ETAPE_INFO[etape];
  return (
    <span className={`pastille etape-${etape}${grande ? ' grande' : ''}`}>
      {variante === 'numero' ? (
        <span className="num" aria-hidden="true">
          {info.num}
        </span>
      ) : (
        <span className="icone">
          <IconeEtape etape={etape} />
        </span>
      )}
      <span className="texte">
        <span className="libelle">
          <span className="sr-only">Étape {info.num} · </span>
          {info.label}
        </span>
        {detail ? <span className="detail">{detail}</span> : null}
      </span>
    </span>
  );
}

/** Pilule compacte « Entrée » / « Plat » / « Dessert » (états : pleine, teintée, vide en pointillé). */
export function PilluleEtape({ etape, etat = 'teinte' }: { etape: Etape; etat?: 'pleine' | 'teinte' | 'vide' }) {
  return <span className={`pill-etape etape-${etape}${etat === 'pleine' ? ' pleine' : etat === 'vide' ? ' vide' : ''}`}>{ETAPE_INFO[etape].label}</span>;
}
